module.exports = __webpack_public_path__ + "47007e0863b061227d1e8c8303280f79.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ky.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ky.svg
// module chunks = 0